import { adaptHtml } from "adapters/base";
import { getGecoComponentsList } from "adapters/gecoComponentList";

const prepareContentByDraft = (detail, showDraft) => {
  let detailMapped = {};

  if (detail.state === 'PUBLISH_NO_DRAFT' || (detail.state === 'PUBLISH_WITH_DRAFT' && !showDraft)) {
    detailMapped = {
      ...detail,
      content: {
        ...detail?.contentVersionCurrent,
      },
    };
    delete detailMapped?.contentVersionCurrent;
  } else {
    detailMapped = {
      ...detail,
      content: {
        ...detail?.contentVersionDraft,
      },
    };
    delete detailMapped?.contentVersionDraft;
  }
  return detailMapped;
};

export const mapperResponseToNewDetail = (detail, showDraft, countryIso, languageIso) => {
  const newDetail = prepareContentByDraft(detail, showDraft);
  const language = getLanguageToGetValues(countryIso, languageIso);
  newDetail.gecoComponents = getGecoComponentsList(newDetail.content.contentFields, language);
  newDetail.title = adaptHtml(newDetail.content.contentFields, "title", language);
  return newDetail;
};

const getLanguageToGetValues = (countryIso, languageIso) => {
  let countryLanguageCode = languageCodes.find((idiomaticVariant) => idiomaticVariant.country === countryIso);
  if (!countryLanguageCode) {
    return languageIso;
  }
  if (!countryLanguageCode.languageiso.includes(languageIso)) {
    return languageIso;
  }

  return countryLanguageCode.languageCode;
};

const languageCodes = [
  {
    country: 'BR',
    languageiso: ['pt'],
    languageCode: 'pt_BR',
  },
  {
    country: 'PT',
    languageiso: ['pt'],
    languageCode: 'pt_PT',
  },
  {
    country: 'TW',
    languageiso: ['zh', 'zt'],
    languageCode: 'zh_TW',
  },
  {
    country: 'HK',
    languageiso: ['zh', 'zt'],
    languageCode: 'zh_TW',
  },
  {
    country: 'CN',
    languageiso: ['zh'],
    languageCode: 'zh_CN',
  },
];
